import { useCurrency } from "@/composables/useCurrency";
import client from "@/utils/axios";
import { isZero } from "@/utils/math";
import dayjs from 'dayjs';

export default {
  namespaced: true,
  
  state() {
    return {
      data: null
    }
  },

  mutations: {
    SET_DATA(state, data) {
      state.data = data;
    }
  },

  actions: {
    async fetch({ commit }, period) {
      const params = {
        startDate: dayjs(period.start).format("YYYY-MM-DD"),
        endDate: dayjs(period.end).format("YYYY-MM-DD")
      }

      try {
        const { data } = await client.get("/api/pnl/details", { params });
        commit('SET_DATA', data);
      } catch {
        // nothing
      }
    }
  },

  getters: {
    pnl(state, getters, rootState, rootGetters) {
      const { convertToView } = useCurrency();

      if (!state.data) {
        return [];
      }

      const { transfers, totalLoans, totalEarns } = state.data;

      const items = transfers.map(item => {
        return {
          apiKeyUuid: item.apiKeyUuid,
          exchangeId: item.exchangeId,
          exchange: rootGetters.getExchangeFullName(item.exchangeId),
          account: rootGetters['portfolio/getApiKey'](item.apiKeyUuid)?.name,
          close: item.closeBalance[convertToView.value],
          open: item.openBalance[convertToView.value],
          realised: item.realizedPnl[convertToView.value],
          unrealised: item.unrealizedPnl[convertToView.value],
          total: item.totalPnL[convertToView.value],
          withdrawals: item.withdrawl[convertToView.value],
          deposits: item.deposit[convertToView.value],
        }
      })

      if (totalLoans && !isZero(totalLoans.closeBalance[convertToView.value]) && !isZero(totalLoans.openBalance[convertToView.value]) && !isZero(totalLoans.totalPnL[convertToView.value])) {
        totalLoans.totalPnL[convertToView.value] = totalLoans.totalPnL[convertToView.value] * -1

        items.push({
          exchangeId: rootGetters.exchangeNames.BEQUANT,
          exchange: 'Total Loans',
          close: totalLoans.closeBalance[convertToView.value],
          open: totalLoans.openBalance[convertToView.value],
          realised: totalLoans.totalPnL[convertToView.value],
          total: totalLoans.totalPnL[convertToView.value],
          unrealised: 0,
          deposits: 0,
          withdrawals: 0
        });
      }

      if (totalEarns && !isZero(totalEarns.closeBalance[convertToView.value]) && !isZero(totalEarns.openBalance[convertToView.value]) && !isZero(totalEarns.totalPnL[convertToView.value])) {
        items.push({
          exchangeId: rootGetters.exchangeNames.BEQUANT,
          exchange: 'Total Earn',
          close: totalEarns.closeBalance[convertToView.value],
          open: totalEarns.openBalance[convertToView.value],
          realised: totalEarns.totalPnL[convertToView.value],
          total: totalEarns.totalPnL[convertToView.value],
          unrealised: 0,
          deposits: 0,
          withdrawals: 0
        });
      }

      return items;
    },
  }
};